import { render, staticRenderFns } from "./ShareViewDialog.vue?vue&type=template&id=675dfdfa&scoped=true&"
import script from "./ShareViewDialog.vue?vue&type=script&lang=js&"
export * from "./ShareViewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675dfdfa",
  null
  
)

export default component.exports